// import { EditorState } from '@codemirror/state';
import { syntaxTree } from '@codemirror/language';

// import { StringStream } from '@codemirror/language';
import { octave } from '@codemirror/legacy-modes/mode/octave';
import { Tag, tags } from '@lezer/highlight';

import {
    OPERATOR_KEYS,
    STRING_KEYS,
    METRIC_DELIMITER_KEYS,
    TOKEN_TYPES,
    METRIC_REGEX
} from './consts';

export const countMetric = (docStr = '') => {
  return docStr.match(METRIC_REGEX)?.length ?? 0;
};

export const removeTrailingSpecialChars = (str) => {
  return str.replace(/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9]+$/, '');
};

export const getCursor = (state) => state.selection.main.head;
// export const getToken = (state, side?: -1 | 0 | 1) => {
export const getToken = (state, side) => {
  const cursor = getCursor(state);
  return syntaxTree(state).resolve(cursor, side).node;
};
export const getTokenAtPos = (
  state,
  pos,
  side
) => {
  return syntaxTree(state).resolveInner(pos, side).node;
};


export const tokenParser = (stream, state) => {
  if (stream.eatSpace()) return null;

  let ch = stream.next();

  // metric 토큰: ^*로 시작하고 *^로 끝나는 부분
  if (ch === '^' && stream.peek() === '*') {
    stream.next();

    while ((ch = stream.next())) {
      if (ch === '*' && stream.peek() === '^') {
        stream.next();
        break;
      }
    }
    return TOKEN_TYPES.METRIC;
  }

  // operator 토큰
  if (ch && OPERATOR_KEYS.test(ch)) return TOKEN_TYPES.OPERATOR;

  // string 토큰: 문자열로 시작하고 operator 이전까지
  if (ch && STRING_KEYS.test(ch)) {
    stream.eatWhile(
      (ch) => !OPERATOR_KEYS.test(ch) && !METRIC_DELIMITER_KEYS.test(ch)
    );
    return TOKEN_TYPES.STRING;
  }

  // number 토큰: octave 모드
  stream.backUp(1);
  return octave.token(stream, state);
};

const metricTag = Tag.define(TOKEN_TYPES.METRIC);
export const tokenTable = {
  metric: metricTag,
  operator: tags.operator,
  number: tags.number,
  string: tags.string,
};

export const highlightStyles = [
  { tag: tags.number, color: '#116644', fontSize: '13px' },
  { tag: tags.operator, color: '#080A0D', fontSize: '13px' },
  { tag: tags.string, color: '#AA1111', fontSize: '13px' },
  {
    tag: metricTag,
    class: 'cm-metric',
  },
];

export const checkIsValidFormula = (formula) => {
  return (
    !!formula &&
    checkValidMetric(formula) &&
    checkValidParentheses(formula) &&
    checkValidMathExpression(formula)
  );
};

const checkValidMetric = (formula) => {
  const refined = formula.replace(METRIC_REGEX, '');

  return !STRING_KEYS.test(refined);
};

const checkValidParentheses = (formula) => {
  const stack = [];

  for (let i = 0; i < formula.length; i++) {
    const char = formula[i];

    if (char === '(') {
      stack.push(char);
    } else if (char === ')') {
      if (stack.length === 0) {
        return false;
      }
      stack.pop();
    }
  }

  return stack.length === 0;
};

const checkValidMathExpression = (formula) => {
  const refined = R.compose(
    R.replace(/[()]/g, ''),
    R.replace(METRIC_REGEX, 'm')
  )(formula);

  // 사칙연산 수식이 유효하지 않은 경우
  // 1. m(메트릭) 뒤에 연산자가 아닌 문자가 오는 경우
  // 2. 연산자가 연속해서 오는 경우
  // 3. 숫자 뒤에 m(메트릭)이 오는 경우
  // 4. 연산자로 끝나는 경우
  // 5. 소수점 앞에 숫자가 오지 않는 경우
  // 6. 소수점 뒤에 숫자가 오지 않는 경우
  // 7. 소수점이 여러개인 경우 (1.11.11)
  const invalidExpressionRegex =
    /m[^+\-*/]|[+\-*/]{2,}|\d+m|[+\-*/]$|(?:([^0-9]|^)\.|\.([^0-9]|$))|\d+(\.\d*){2,}/;

  return !invalidExpressionRegex.test(refined);
};
